import _DTO from "./_DTO";
import PowerSupplyDTO from "./PowerSupplyDTO";


export default class PowerSupplyGroupDTO extends _DTO {

  constructor(powerSupplyGroup) {
    super();
    this.name = PowerSupplyGroupDTO.getOrDefault(powerSupplyGroup, 'name', null);
    this.powerSupply = PowerSupplyGroupDTO.getMappedOrDefault(powerSupplyGroup, 'powerSupply', null, data => {
      if (data == null) {
        return null;
      }
      return new PowerSupplyDTO(data);
    });
    this.islandsSlots = PowerSupplyGroupDTO.getOrDefault(powerSupplyGroup, 'islandsSlots', []);
  }
}
